import React, {useEffect, useCallback, useState} from 'react'
import { useNavigate } from "react-router-dom";
import { getUnatHolders } from '../../util/api'
import { debounce } from 'lodash';
import { 
  Spinner,
  IconButton,
  Typography,
  Input,
  Progress,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from '@material-tailwind/react';
import { formatUnixTime } from '../../util/format-data';
import { v4 as uuidv4 } from 'uuid';
import { formatAddress } from '../../util/format-data';
import Op20IndexerDetail from './Op20IndexerDetail';
import { getOp20Indexer, getOp20DomainIndex, getOp20DomainHolders } from '../../util/op20-api';
import { useTranslation } from 'react-i18next';
import { formatFloat } from '../../util/format-data';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { formatNumberWithCommas } from '../../util/format-data';
import { convertTimestampToDate } from '../../util/format-data';
import { toast } from 'react-hot-toast';

export default function Op20Indexer() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [ticker, setTicker] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [totalHolders, setTotalHolders] = useState(0);
  const [sort, setSort] = useState(0); // 0: holders, 1: supply, 2: percentage, 4: createdAt
  const [direct, setDirect] = useState(1); // 0: ASC, 1: DESC
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [detailticker, setDetailTicker] = useState('op');
  const [holders, setHolders] = useState([]);
  const [holdersPage, setHoldersPage] = useState(1);
  const [holdersLimit, setHoldersLimit] = useState(10);
  const [holdersTotal, setHoldersTotal] = useState(0);
  const [holdersQuery, setHoldersQuery] = useState('');

  useEffect(() => {
    if (showDetail) {
      fetchTokenData(detailticker, page);
    }
  }, [page, sort, direct, showDetail])

  useEffect(() => {
    if (!showDetail) {
      fetchTokenHolders(holdersQuery, holdersPage);
    }
  }, [holdersPage, showDetail])

  const fetchTokenHolders = async (value, page) => {
    setLoading(true);
    let data = await getOp20DomainHolders(value, page, holdersLimit);
    setHolders(data.data);
    setHoldersTotal(Math.ceil(data.total / holdersLimit));
    setLoading(false);
  }

  const debouncedSearchHolders = useCallback(debounce( async (value) => {
    fetchTokenHolders(value, 1);
    setHoldersPage(1);
  }, 800), []);

  const handleHoldersSearch = (value) => {
    debouncedSearchHolders(value);
    setHoldersQuery(value);
  }

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }

  const holdersNext = () => {
    if (holdersPage === holdersTotal) return;
    setHoldersPage(holdersPage + 1);
  };
 
  const holdersPrev = () => {
    if (holdersPage === 1) return;
    setHoldersPage(holdersPage - 1);
  };

  const holdersDoublePrev = () => {
    setHoldersPage(1);
  }

  const holdersDoubleNext = () => {
    setHoldersPage(holdersTotal);
  }

  const handleKeyChange = (e) => {
    setTicker(e.target.value)
    debouncedSearch(e.target.value)
  }

  const handleOrder = (value) => {
    setSort(value);
    setDirect(1 - direct);
  }

  const debouncedSearch = useCallback(debounce( async (value) => {
    try {
      await fetchTokenData(value, 1);
      setPage(1);
    }
    catch (e) {
      console.log(e);
    }
  }, 300), []); 

  const fetchTokenData = async (value, page) => {
    setLoading(true);
    let data = await getOp20DomainIndex(value, detailticker, page, limit);
    setDatas(data.data);
    setTotal(Math.ceil(data.total / limit));
    setTotalHolders(data.total);
    setLoading(false);
  }

  const showDetailIndexer = (value) => {
    setDetailTicker(value);
    setShowDetail(true);
  }

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    toast.success(t('Copied to clipboard'));
  }

  return (
    <div className="text-white w-full max-w-[1800px] flex flex-col justify-center items-center">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      {
        !showDetail ? 
        <>
          { 
            <div className="mt-5 flex flex-row w-full justify-end gap-2 max-w-[500px]">
              <div>
                <Input type="text" color="white" label = {t('Search By TLD')} className="w-[250px]" value = {holdersQuery} onChange = {(e) => {handleHoldersSearch(e.target.value)}}/>
              </div>
            </div>
          }
          <div className="flex flex-col gap-2 max-w-[500px] w-full mt-8">
            <div className="flex flex-row px-4 py-2 items-center">
              <div className = "w-[40%] text-center">{t('Domain')}</div>
              <div className = "w-[30%] text-center">{t('Holders')}</div>
              <div className = "w-[30%] text-center">{t('Names')}</div>
            </div>
            {
              holders.map((data) => 
                <div 
                  className="flex flex-row gap-1 items-center text-white bg-gray-900 p-4 rounded-lg cursor-pointer hover:bg-gray-800" 
                  key={uuidv4()}
                  onClick={() => showDetailIndexer(data.type)}
                >
                  <div className = "w-[40%] break-words text-primary text-center">{data.type}</div>
                  <div className = "w-[30%] text-center">{formatNumberWithCommas(data.holders)}</div>
                  <div className = "w-[30%] text-center">{formatNumberWithCommas(data.total)}</div>
                </div>
              )
            }
          </div>
          {
            holdersTotal > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={holdersDoublePrev}
                  disabled={holdersPage === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={holdersPrev}
                  disabled={holdersPage === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{holdersPage}</strong> of{" "}
                <strong className="text-primary">{holdersTotal}</strong>
              </Typography>
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={holdersNext}
                  disabled={holdersPage === holdersTotal}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={holdersDoubleNext}
                  disabled={holdersPage === holdersTotal}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
            :
            <></>
          }
        </>
        : 
        <>
          {
            <div className="flex flex-col gap-2 max-w-[800px] w-full mt-8">
              <div className="mt-3 font-bold text-primary text-[24px] flex flex-row gap-2 items-center">
                <ArrowLeftIcon strokeWidth={3} className="h-5 w-5 cursor-pointer" onClick={() => setShowDetail(false)}/>
                <div className="break-words sm:max-w-[800px] max-w-[300px]">{detailticker.toUpperCase()} ({totalHolders})</div>
              </div>
              { 
                <div className="mt-5 flex flex-row w-full justify-end gap-2">
                  <div>
                    <Input type="text" color="white" label = {t('Search By Name')} className="w-[250px]" value = {ticker} onChange = {(e) => {handleKeyChange(e)}}/>
                  </div>
                </div>
              }
              <div className="flex flex-row px-4 py-2 items-center">
                <div className = "w-[40%]">{t('Name')}</div>
                <div className = "w-[30%]">{t('Address')}</div>
                <div className = "w-[30%]">{t('TxId')}</div>
              </div>
              {
                datas.map((data) => 
                  <div 
                    className="flex flex-row gap-1 items-center text-white bg-gray-900 p-4 rounded-lg" 
                    key={uuidv4()}
                  >
                    <div className = "w-[40%] break-words text-primary">{data.domain}</div>
                
                    <div className = "w-[30%] cursor-pointer hover:text-primary" onClick={() => handleCopy(data.address)}>{formatAddress(data.address)}</div>
                    <div className = "w-[30%] cursor-pointer hover:text-primary">
                      <a href={`https://mempool.space/tx/${data.txId.split(':')[0]}`} target="_blank" rel="noopener noreferrer" >{formatAddress(data.txId.split(':')[0])}</a></div>
                  </div>
                )
              }
            </div> 
          }
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doublePrev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={next}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doubleNext}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
            :
            <></>
          }
        </>
      }
      
    </div>
  )
}
